import * as v from 'valibot';

import { newSchema } from '../../../../../utils/valibot/schema';

export const RetailCrmUpdateAccountResponseSchema = newSchema(
  'RetailCrmUpdateAccountResponseSchema',
  v.object({
    success: v.boolean(),
    id: v.optional(v.string()),
  }),
);

export type RetailCrmUpdateAccountResponse = v.InferOutput<typeof RetailCrmUpdateAccountResponseSchema>;
